export default "__VITE_ASSET__DnRtZ6WP__"